import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Changes the selections when the current list changes
 */
export const onChangeInCurrentList = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) => {
    const { onChangeInCurrentList: onChange } = plugin.config
    if (!onChange) {
      return
    }

    return plugin.collection.plugins.currentListPlugin.feature.selectors.entities.asObservable.pipe(
      // Prevents emissions until the entity collection is ready
      rxjsUtils.delayUntil(plugin.collection.ready$, { maxDelayed: 1 }),
      // Gets current selection
      rxjsUtils.latestFrom(entities => ({
        currentSelections:
          plugin.applied.selectors.selectionLookup.asObservable,
        entities: rxjs.of(entities),
      })),
      // Creates the update actions
      rxjs.switchMap(({ currentSelections, entities }) => {
        const results = onChange(entities, currentSelections)
        return plugin.applied.actions.putInSelectionLookup
          .from('onChangeInCurrentList (effect)')
          .bulkCreate(
            ...Object.entries(results)
              .map(([target, instruction]) =>
                instruction === undefined
                  ? undefined
                  : { key: target, value: instruction },
              )
              .filter(TypeChecker.isNotNullish.raw),
          )
      }),
    )
  },
)
